module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm6_m_en.70dab531c3a0ea733ac496882a18ae1b.png";